import { graphql } from 'react-relay';

export const checkHometaxAccount = graphql`
  mutation checkHometaxAccountMutation(
    $corpType: CorpTypeEnum!
    $loginType: LoginType!
    $certificate: Certificate
    $hometaxAccount: HometaxAccount
    $hometaxCookies: String
    $simpleAuth: SimpleAuth
    $tin: String
  ) {
    checkHometaxAccount(
      corpType: $corpType
      loginType: $loginType
      certificate: $certificate
      hometaxAccount: $hometaxAccount
      hometaxCookies: $hometaxCookies
      simpleAuth: $simpleAuth
      tin: $tin
    ) {
      result
      errors {
        code
      }
      refundToken
      email
      lastLoginType
    }
  }
`;
